import script from "./AdminPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPagination.vue?vue&type=script&setup=true&lang=js"

import "./AdminPagination.vue?vue&type=style&index=0&id=3c46d980&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c46d980"]])

export default __exports__